import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { showUpgradeModal } from 'reducers/featureRestrictions/actions';
import isMokaposUser from 'selectors/isMokaposUser';
import styles from './style.css';
import SidebarLockedItem from './SidebarLockedItem';
import SidebarItem from './SidebarItem';

const itemDefinitions = [
  {
    title: 'Sales Summary',
    link: '/reports/sales/summary',
    posOnly: false,
  },
  {
    title: 'Gross Profit',
    link: '/reports/sales/gross_profit',
    posOnly: true,
  },
  {
    title: 'Payment Methods',
    link: '/reports/sales/payment_methods',
    posOnly: false,
  },
  {
    title: 'Sales Type',
    link: '/reports/sales/sales_type',
    posOnly: false,
  },
  {
    title: 'Item Sales',
    link: '/reports/sales/item_sales',
    posOnly: false,
  },
  {
    title: 'Category Sales',
    link: '/reports/sales/category_sales',
    posOnly: true,
  },
  {
    title: 'Modifier Sales',
    link: '/reports/sales/modifier_sales',
    posOnly: true,
  },
  {
    title: 'Discounts',
    link: '/reports/sales/discounts',
    posOnly: false,
  },
  {
    title: 'Taxes',
    link: '/reports/sales/taxes',
    posOnly: true,
  },
  {
    title: 'Gratuity',
    link: '/reports/sales/gratuity',
    posOnly: true,
  },
  {
    title: 'Collected By',
    link: '/reports/sales/staff',
    posOnly: true,
  },
  {
    title: 'Served By',
    link: '/reports/sales/server',
    posOnly: true,
  },
];

class SidebarReports extends React.Component {
  render() {
    const {
      location,
      elementClass,
      onLockedItemClick,
      onToggle,
      restrictedMode,
    } = this.props;
    const path = location.pathname;

    const sidebarItems = itemDefinitions.map((item, index) => {
      const { link, posOnly, title } = item;

      if (restrictedMode && posOnly) {
        return (
          <SidebarLockedItem onClick={onLockedItemClick}>
            {title}
          </SidebarLockedItem>
        );
      }

      return (
        <SidebarItem key={index} to={link} isActive={path.startsWith(link)}>
          {title}
        </SidebarItem>
      );
    });

    const menuClassNames = classNames(
      'col-xs-12',
      'col-sm-12',
      styles.slideMenu,
      elementClass
    );

    return (
      <div className={menuClassNames} id="sideMenu">
        <div className={styles.hide}>
          <div className="mk-sidebar-box">
            <ul className={`mk-side-nav ${styles['side-list']}`}>
              <li
                className="head visible-sm visible-xs text-bold"
                onClick={onToggle}
              >
                Side Menu
                <i className="fa fa-close pull-right" id="close-menu" />
              </li>
              {sidebarItems}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

SidebarReports.propTypes = {
  elementClass: PropTypes.string,
  location: PropTypes.object.isRequired,
  onLockedItemClick: PropTypes.func,
  onToggle: PropTypes.func,
  restrictedMode: PropTypes.bool,
};

SidebarReports.defaultProps = {
  elementClass: '',
  onLockedItemClick: () => {},
  onToggle: () => {},
  restrictedMode: false,
};

const mapStateToProps = state => {
  return {
    restrictedMode: !isMokaposUser(state),
  };
};

const mapDispatchToProps = {
  onLockedItemClick: showUpgradeModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SidebarReports);
